module.exports = __webpack_public_path__ + "assets/RetinaNarr-ExLight.5c6004b7c8c0ab1aa510fdf8bf7bd5f0.woff";